import React from "react";

import CategoryDetails from "components/CategoryDetails";
import { amenitiesFilmdata } from "utils/static";

function AmenitiesDisplay() {
  return (
    <CategoryDetails
      title="Amenities Display"
      defaultData={amenitiesFilmdata}
      backUrl="/"
      isBottomBack
      isParentImage
    />
  );
}

export default AmenitiesDisplay;
